// Builds a table of contents from a policy/page content block, with scroll-spy.
// Vanilla JS (no Alpine registration dependency) so it works regardless of script order.
(function () {
  function getScrollParent(el) {
    var node = el ? el.parentElement : null;
    while (node && node !== document.body && node !== document.documentElement) {
      var oy = getComputedStyle(node).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && node.scrollHeight > node.clientHeight + 4) {
        return node;
      }
      node = node.parentElement;
    }
    return window;
  }

  // Fallback for Shopify's default Terms-of-Service markup: one <p> with bold
  // section titles (<strong> at the start of a line) separated by <br>, and no
  // real headings. Treat those line-leading <strong> as section headings.
  function findPseudoHeadings(root) {
    var bolds = Array.prototype.slice.call(root.querySelectorAll('strong, b'));
    var result = [];
    bolds.forEach(function (el) {
      var txt = el.textContent.trim();
      if (!txt || txt.length > 80) return;
      var prev = el.previousSibling;
      while (prev && prev.nodeType === 3 && !prev.textContent.trim()) {
        prev = prev.previousSibling;
      }
      var lineStart = !prev || prev.nodeName === 'BR';
      if (lineStart) {
        el.classList.add('toc-pseudo-heading');
        result.push(el);
      }
    });
    return result;
  }

  function slugify(str) {
    return (
      str
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/&/g, ' et ')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || 'section'
    );
  }

  function initToc(container) {
    var content = container.querySelector('[data-toc-content]');
    if (!content) return;
    // On Shopify policy pages the real content sits in .shopify-policy__body
    // (the page title h1 lives in .shopify-policy__title, which we want to skip).
    var scanRoot = content.querySelector('.shopify-policy__body') || content;

    var selector = container.getAttribute('data-toc-levels') || 'h1,h2,h3';
    var headings = Array.prototype.slice
      .call(scanRoot.querySelectorAll(selector))
      .filter(function (h) {
        return h.textContent.trim().length > 0;
      });

    // No real headings (e.g. Shopify default Terms of Service) -> derive from bold lines.
    if (!headings.length) {
      headings = findPseudoHeadings(scanRoot);
    }

    if (!headings.length) {
      container.classList.add('toc-empty');
      return;
    }

    var used = {};
    var items = headings.map(function (h) {
      var id = h.id;
      if (!id) {
        var base = slugify(h.textContent);
        var cand = base;
        var i = 2;
        while (used[cand] || document.getElementById(cand)) {
          cand = base + '-' + i++;
        }
        id = cand;
        h.id = id;
      }
      used[id] = true;
      return {
        id: id,
        text: h.textContent.trim(),
        level: h.tagName === 'H3' ? 2 : 1,
        el: h,
      };
    });

    var lists = container.querySelectorAll('[data-toc-list]');
    Array.prototype.forEach.call(lists, function (ul) {
      ul.innerHTML = '';
      items.forEach(function (it) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + it.id;
        a.textContent = it.text;
        a.className = 'toc-link toc-level-' + it.level;
        a.setAttribute('data-toc-id', it.id);
        a.addEventListener('click', function (e) {
          e.preventDefault();
          it.el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (history.replaceState) {
            history.replaceState(null, '', '#' + it.id);
          }
          // Let the mobile dropdown (Alpine) close itself.
          a.dispatchEvent(new CustomEvent('toc-navigate', { bubbles: true }));
        });
        li.appendChild(a);
        ul.appendChild(li);
      });
    });

    container.classList.add('toc-ready');

    // Scroll-spy: the active section is the last heading scrolled above the
    // activation line. This always reflects the current section, even when no
    // heading is on screen (long sections).
    var links = container.querySelectorAll('.toc-link');
    function setActive(id) {
      Array.prototype.forEach.call(links, function (a) {
        var on = a.getAttribute('data-toc-id') === id;
        a.classList.toggle('is-active', on);
        if (on) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
    }

    function stickyOffset() {
      var v = getComputedStyle(document.documentElement).getPropertyValue('--sticky-offset');
      var n = parseInt(v, 10);
      return isNaN(n) ? 0 : n;
    }

    var ticking = false;
    function updateActive() {
      ticking = false;
      var line = stickyOffset() + 140;
      var currentId = items[0].id;
      for (var i = 0; i < items.length; i++) {
        if (items[i].el.getBoundingClientRect().top <= line) currentId = items[i].id;
        else break;
      }
      setActive(currentId);
    }
    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateActive);
      }
    }
    updateActive();
    // The theme scrolls inside an internal container, so window 'scroll' may not
    // fire. Listen on window, on document (capture catches scrolls from any
    // descendant scroller), and on the detected scroll parent.
    var scroller = getScrollParent(container);
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    if (scroller && scroller !== window) {
      scroller.addEventListener('scroll', onScroll, { passive: true });
    }
    window.addEventListener('resize', onScroll, { passive: true });
  }

  function boot() {
    var containers = document.querySelectorAll('[data-toc]');
    Array.prototype.forEach.call(containers, initToc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
